modal = {
    // Funkcia sluzi na toggle checkboxu v modalnom okne freebetu a odoslanie prikazu na vypnutie zobrazovania fb modalneho okna
    noMoreFBModal: function(submit) {
        try {
            var showFbModalCheckbox = $("#universalModal #noMoreFbModal");
            if ((showFbModalCheckbox).attr("checked")) {
                if (submit) {
                    // Potvrdenie fb okna klientom
                    main.closeDialog();
                    DisableFbModal();
                } else {
                    // Toggle checkbox
                    showFbModalCheckbox.attr("checked", false);
                }
            } else {
                if (submit) {
                    // Potvrdenie fb okna klientom
                    main.closeDialog();
                } else {
                    // Toggle checkbox
                    showFbModalCheckbox.attr("checked", true);
                }
            }
            return true;
        } catch (e) {
            // V pripade chyby zrusi fb okno
            main.closeDialog();
            return false;
        }
    },

    // Funkcia vytvara html pre vlc
    universalModalInnerVLC: function() {
        try {
            this.qrCode = "";
            if (!this.noQR) {
                this.qrCode = "<div class='qr-code qr-first " + offer.country + " "
                + (this.isCustomQR? "custom": "") + "'></div><div class='qr-code qr-second " + offer.country + " "
                + (this.isCustomQR? "custom": "") + "'></div>";
            }
            return "<div id='"
            + this.modalFor + "Content' class='"
            + this.mState + "'><div id='"
            + this.modalFor + "ModalIcon'></div><div id='"
            + this.modalFor + "Container'><div id='modalHeader'>"
            + this.mHeader + "</div><div id='textWrapper' class='flex-container'><div id='infoIcon'></div><div id='infoText'>"
            + this.mInfo + "</div></div><div id='modalFooter'>"
            + this.mFooter + "</div><div id='additionalTextWrapper' class='flex-container'><div id='infoAdditionalText'>"
            + this.qrInfoText + "</div>"
            + this.qrCode
            + ((this.mButtonText)?"<a id='modalButton' data-role='button' data-theme='a' onmousedown='"
            + this.mButtonCall + "'>"
            + this.mButtonText + "</a>":"") + "</div>";
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        }
    },

    // Funkcia vytvara html pre jackpot modal
    universalModalInnerJackpot: function() {
        try {
            return "<div id='"
            + this.modalFor + "Content' class='"
            + this.mState + "'><div id='"
            + this.modalFor + "Container'><div id='modalHeader'>"
            + this.mHeader + " "
            + this.mInfo + "</div><div id='modalBonusValue'>"
            + this.mBonusValue + "</div>"
            + "<a id='jackpotButton' data-role='button' data-theme='a' onmousedown='main.closeDialog()'>"
            + this.mBonusClose + "</a></div>";
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        }
    },

    // Funkcia zabezpecuje skryvanie tooltipu
    hideTooltip: function() {
        try {
            dialog.isOpen("tooltipWrapperDialog") && dialog.close("tooltipWrapperDialog");
            stored.actionsHandling.tooltipMousedown = false;
            return true;
        } catch(e) {
            return false;
        }
    },

    // Funkcia zabezpecuje zobrazovanie tooltipu (ECT v detaile zapasu, v okne automatickeho vyplatenia tiketu, XXL Bonus v detaile tiketu a na rozrobenom tikete)
    showTooltip: function(refTooltipIcon, tooltipText, showttOverlay, horizontalShift, verticalShift) {
        try {
            stored.actionsHandling.tooltipMousedown = true;
            if (dialog.isOpen("tooltipWrapperDialog")) {
                modal.hideTooltip();
                return true;
            } else if (refTooltipIcon) {
                if (!horizontalShift) horizontalShift = 0;
                if (!verticalShift) verticalShift = 0;
                var ttPosition = $(refTooltipIcon).offset();
                var ttTop = Math.round(ttPosition.top + verticalShift);
                var ttLeft = Math.round(ttPosition.left + horizontalShift);
                var ttText = tooltipText ? tooltipText : $(refTooltipIcon).attr("tooltip-containing-text");
                dialog.open({
                    id: "tooltipWrapperDialog",
                    modal: showttOverlay == true ? true : false,
                    fullScreen: showttOverlay == true ? true : false,
                    cssClass: showttOverlay == true? "tooltip--with-overlay" : "",
                    persistent: false,
                    parseJQM: false,
                    content: `
                        <div id="tooltipWrapper" onmousedown="modal.hideTooltip()">
                            <div class="tooltip-content" >${ttText}</div>
                            <div class="tooltip-triangle">
                                <div class="triangle-bottom"></div>
                            </div>
                        </div>
                    `,
                    backdropDismissOverride: "modal.hideTooltip();",
                    // ak je tooltip s overlayom, vlozime ho do body, aby bol nad vsetkym, ak je bez overlayu, vlozime ho do aktualneho top dialogu, aby sa zobrazil nad nim
                    parentElement: showttOverlay == true ? document.body : dialog.getCurrentTop() || document.body,
                    // ak je modal, nastavujem pozíciu contentu
                    onShow: showttOverlay ? function() { 
                            document.getElementById("tooltipWrapper").style.top = ttTop + "px";
                            document.getElementById("tooltipWrapper").style.left = ttLeft + "px";
                        } : function() {
                            document.getElementById("tooltipWrapperDialog").style.top = ttTop + "px";
                            document.getElementById("tooltipWrapperDialog").style.left = ttLeft + "px";
                        },
                });
                return true;
            }
        } catch(e) {
            console.error(e);
            return false;
        }
    },

    // Funkcia na zobrazenie error hlasky (pouziva nativeApp)
    showErr: function(sev, duration, err1, err2) {
        try {
            if (err1) {
                if (sev == "error") sev = 1; // nativeApp posiela ako severity "error"
                if (sev == "loading") {
                    sev = 4; // severity "loading" (prebieha overovanie voci RVO)
                    main.lockApp();
                }
                modal.showErrObj(sev, duration, {err1: err1, err2: err2, errType: "native"});
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na zobrazenie error hlasky
    showErrObj: function(sev, duration, {errObj, err1, err2, errType, force}) {
        try {
            if (!errObj && !err1 && !err2) {
                return false;
            } else if (player?.onboarding?.inProgress) {
                // Osetrenie pripadu kedy prebieha onboarding, zmena oddu na rozpracovanom tikete na exspirovany vyvola zatvorenie GDPR/terms and conditions okna a zobrazenie error hlasky, preto v tomto pripade nechceme zobrazovat error hlasku
                return false;
            }
            if (err1 && errType) {
                // Jednoduchy error premapuje do errObj
                if (err2) {
                    // Existuje err2
                    errObj = {
                        [errType + "_Label"]: err1,
                        [errType]: [{ "errorContent" : err2 }]
                    }
                } else {
                    // Existuje len err1
                    errObj = {
                        [errType + "_Label"]: err1,
                    }
                }
                errObj.errorTypes = [errType];
            }

            var merged = false;
            if (errObj) {
                // Podmienky pre zobrazenie
                var buttonError = (stored.ActualError && stored.ActualError.errorTypes && stored.ActualError.errorTypes.interSection(offer.btnErrors).length);
                if (
                    ((!$.isEmptyObject(ct.errTime) && stored.ActualError)
                     && ((buttonError && errObj.errorTypes[0] === offer.btnErrors[0] ) || errObj.errorTypes[0] === offer.btnErrors[0]))
                     || (buttonError && offer.parallelErrTypes.includes(errType))
                    ) {
                    // Ak je aktualne zobrazeny alebo sa ma zobrazit Button error
                    if (force && (forcedTypes = errObj.errorTypes.interSection(offer.btnErrors)) && forcedTypes.length) {
                        // Tu uz pride aktualizovany zoznam exspirovanych oddov staci ho PRIRADIT DO errObj
                        // Mergovat treba hotovy errObj s aktualnym errorom ak exsituej
                        if (stored.ActualError.errorTypes.includes(forcedTypes[0])) {
                            stored.ActualError[forcedTypes[0]] = errObj[forcedTypes[0]];
                        } else {
                            stored.ActualError = errObj;
                        }
                    } else {
                        if (!stored.ActualError.errorTypes.includes(errObj.errorTypes[0])) {
                            stored.ActualError.errorTypes.push(errObj.errorTypes[0]);
                        }
                        var originalError = JSON.stringify(stored.ActualError.errorTypes);
                        merge(stored.ActualError, errObj);
                        stored.ActualError.errorTypes = JSON.parse(originalError);
                    }
                    merged = true;
                }
                if (((!$.isEmptyObject(ct.errTime) && stored.ActualError) && (errObj.errorTypes[0] === "ERR_RATEX"))) {
                    // Ak je aktualne zobrazeny alebo sa ma zobrazit List error
                    // Tu uz pride aktualizovany zoznam listovych poloziek v errore staci ho PRIRADIT DO errObj

                    if (!stored.ActualError.errorTypes.includes(errObj.errorTypes[0])) {
                        stored.ActualError.errorTypes.push(errObj.errorTypes[0]);
                    }
                    var originalError = JSON.stringify(stored.ActualError.errorTypes);
                    merge(stored.ActualError, errObj);
                    stored.ActualError.errorTypes = JSON.parse(originalError);
                    merged = true;
                }
                if (!merged) {
                    stored.ActualError = errObj;
                }

                if (stored.ActualError) {
                    // Vyskladanie error-u
                    var errorString = "";
                    stored.ActualError.errorTypes.forEach(function (errType) {
                        // nadpis
                        errorString += "<li class='err1' error-type='" + errType + "'>" +  stored.ActualError[errType + "_Label"] + "</li>";
                        if (stored.ActualError[errType] && stored.ActualError[errType].length) {
                            stored.ActualError[errType].forEach(function(concreteError) {
                                errorString += "<li class='err2' error-type='" + errType + "'>" +  concreteError.errorContent + "</li>";
                            });
                        }
                    });
                }

                // Pridanie / odstranenie tlacitka
                if (ct.errTime) {
                    if (ct.errTime.ERR_ODDEXP) {
                        $("#error #hideErrButton").text(texts.OddsClear).attr("onmousedown", "ticket.ticketOddModule.removeOddsExp();").show();
                    } else if (ct.errTime.ERR_RATEX || offer.btnErrors.includes(errType)) {
                        $("#error #hideErrButton").text(texts.ConfirmButtonOK).attr("onmousedown", "modal.hideErr(true);").show();
                    } else {
                        $("#error #hideErrButton").hide();
                    }
                } else {
                    $("#error #hideErrButton").hide();
                }

                if (sev == 1 && !rfs.approve && !offer.vgL.uofTennis.includes(offer.leagueCupID) && !$.mobile.activePage.is("#quickBetWrapper")) main.closeDialog();
                var buttonError = stored.ActualError.errorTypes.some(function(errType) { return offer.btnErrors.includes(errType); });
                if (ct.errSev != 1 && ct.errSev != 4 
                    || (stored.ActualError && stored.ActualError.errorTypes && buttonError)
                    || (stored.ActualError && stored.ActualError.errorTypes && $.isEmptyObject(ct.errTime))) {
                    // Ak je zobrazeny error sev 2, 3 alebo button error
                    if (!$.isEmptyObject(ct.errTime) && !buttonError) modal.hideErr(false);
                    ct.errSev = sev;
                    if (stored.ActualError) {
                        $("#error ul").html(errorString);
                    } else {
                        $("#error ul").html("<li class='err1'>" + err1 + "</li>");
      
                        if (err2) {
                            $("#error ul").append("<li class='err2'>" + err2 + "</li>");
                            $("#error ul").show();
                        }
                    }
                    dialog.open({
                        id: "errorDialog",
                        backdropDismissOverride: "modal.hideErr(true);",
                        onOpen: function() { $("#error").addClass("err-sev" + sev); },
                        persistent: true,
                        parseJQM: false,
                        closed: function() { $("#error").removeAttr("class").find("#err2").hide(); }
                    });

                    var errorToHide = errObj.errorTypes[0];

                    if (!duration || duration == 0) duration = 5;
                    if (offer.btnErrors.includes(errorToHide)) duration = sets.btnErrorsTime;

                    errObj.errorTypes.forEach(function() {
                        if (!ct.errTime) {
                            ct.errTime = {};
                        }
                    });

                    ct.errTime[errorToHide] = setTimeout(function() {
                        modal.hideErr(false, errorToHide);
                    }, duration * 1000, false, errorToHide);

                    // Pridanie / odstranenie tlacitka
                    if (ct.errTime) {
                        if (ct.errTime.ERR_ODDEXP) {
                            $("#error #hideErrButton").text(texts.OddsClear).attr("onmousedown", "ticket.ticketOddModule.removeOddsExp();").show();
                        } else if (ct.errTime.ERR_RATEX || ct.errTime.ERR_MORECOMBI || offer.btnErrors.includes(errType)) {
                            $("#error #hideErrButton").text(texts.ConfirmButtonOK).attr("onmousedown", "modal.hideErr(true);").show();
                        } else {
                            $("#error #hideErrButton").hide();
                        }
                    } else {
                        $("#error #hideErrButton").hide();
                    }

                } else {
                    // Ak je zobrazena hlaska severity 1 alebo 4 tak sa dalsi error pokusi zobrazit neskor
                    // Retazenie callbackov: ulozi stary callback a vytvori novy, ktory zavola stary + novy error
                    var oldClosed = dialog.getById("errorDialog")._dialogOptions.closed;
                    dialog.getById("errorDialog")._dialogOptions.closed = function() { 
                        if (oldClosed) oldClosed();
                        modal.showErrObj(sev, duration, {errObj: errObj, err1: err1, err2: err2, errType: errType, force}); 
                    };
                }
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na schovanie error hlasky
    hideErr: function(manual, errorTypeToHide) {
        try {
            var hideAll = buttonError = false;
            if (manual === "0") {
                manual = false;
            }

            if (ct.errSev === 4) {
                // Jedna sa o loading hlasku
                if (manual) {
                    // Uzivatel ju nemoze skryt kliknutim
                    return false;
                } else {
                    // NativeApp zavolala hideErr pri loading hlaske, je potrebne odomknut sportbox
                    main.unlockApp();
                }
            }

            if (manual) {
                // Kliknutie uzivatelom - skryje vsetky typy hlasok
                main.userAction();
                hideAll = true;
                list.OddsRateChanged = [];
            } else {
                // Automaticke skrytie hlasky
                if (errorTypeToHide) {
                    // Mal by byt k dispozicii typ na skrytie
                    if (stored.ActualError && stored.ActualError.errorTypes.includes(errorTypeToHide)) {
                        // Mal by byt k dispozicii typ na skrytie
                        if (stored.ActualError.errorTypes.length === 1) {
                            // Posledna hlaska
                            hideAll = true;
                        }
                    }
                }
            }

            if (stored.ActualError && stored.ActualError.errorTypes) {
                buttonError = stored.ActualError.errorTypes.some(function(errType) { return offer.btnErrors.includes(errType); });
            }

            if (!hideAll) {
                // Odstrani len error type ktoreho sa to tyka s odpovedou ci to bol posledny error
                hideAll = modal.clearErrorType(errorTypeToHide);
            }
            if (hideAll) {
                // Button error
                if (buttonError) {
                    list.OddsExpiredHidden = list.OddsExpired.slice();
                }
                // Blok sa pouziva len v pripade ze treba skryt vsetky error hlasky
                delete stored.ActualError;
                if (ct.errTime) {
                    Object.keys(ct.errTime).forEach(function(errTime) {
                        clearTimeout(ct.errTime[errTime]);
                        delete ct.errTime[errTime];
                    });
                }
                ct.errTime = {};
                ct.errSev = null;

                dialog.isOpen("errorDialog") && dialog.close("errorDialog");
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        }
    },

    // Funkcia na zobrazenie informacnej hlasky na potvrdenie
    showInfoModal: function(sev, duration, userCanHide, infoHeader, infoText, infoText2, infoAdditional, buttons) {
        try {
            if (sev !== "AutoLogOffPlayer") {
                main.userAction();
            }
            if (infoHeader) {
                if (ct.errSev != 1) {
                    if (ct.errTime) modal.hideInfoModal();
                    ct.errSev = sev;                    
                    dialog.open({
                        id: "infoModalDialog",
                        onOpen: function() { 
                            $("#infoModal .ui-bar-e").removeClass("two-buttons").find("#confirmInfoButton").hide();
                            $("#infoModal #infoHeader").html(infoHeader).show(); 
                            $("#infoModal").addClass("err-sev" + sev); 
                        },
                        closed: function() { $("#infoModal").removeAttr("class").find(".info-modal-text, .ui-btn").hide(); },
                        backdropDismiss: userCanHide,
                        backdropDismissOverride: userCanHide? "modal.hideInfoModal(true);": null,
                        persistent: true,
                        parseJQM: false
                    });
                    if (!duration || duration == 0) duration = sets.infoModalTime;
                    ct.errTime = setTimeout(function () {
                        // Skryje okno s prihlasenim
                        player.hideBiometryLogin(true);
                        // Skryje okno s informaciou o pokynoch k biometrickemu prihlaseniu
                        modal.hideInfoModal();
                    }, duration);
                    if (infoText) {
                        $("#infoModal #infoText").html(infoText).show();
                    }
                    if (infoText2) {
                        $("#infoModal #infoText2").html(infoText2).show();
                    }
                    if (buttons?.buttonCloseText && buttons?.buttonCloseAction) {
                        $("#infoModal #hideInfoButton").html(buttons.buttonCloseText).attr("onmousedown", buttons.buttonCloseAction).css("display", "inline-block");
                    } else {
                        $("#infoModal .ui-bar-e").find("#hideInfoButton").hide();
                    }
                    if (buttons?.button2Text && buttons?.button2Action) {
                        $("#infoModal .ui-bar-e").addClass("two-buttons").find("#confirmInfoButton")
                        .html(buttons.button2Text).attr("onmousedown", buttons.button2Action).css("display", "inline-block");
                    }
                    if (buttons?.button2CloseAction) {
                        $("#infoModal #hideInfoButton2").attr("onmousedown", buttons.button2CloseAction).html(buttons.button2CloseText? buttons.button2CloseText : texts.ModalVlcClose).show();
                    }
                    if (infoAdditional) {
                        $("#infoModal .ui-bar-e").find("#infoAdditional")
                        .html(infoAdditional).show();
                    }
                    if (buttons?.buttonAdditionalText && buttons?.buttonAdditionalAction) {
                        $("#infoModal .ui-bar-e").find("#infoButtonAdditional")
                        .html(buttons.buttonAdditionalText).attr("onmousedown", buttons.buttonAdditionalAction).css("display", "inline-block");
                    }
                } else {
                    // Ak je zobrazena error hlaska severity 1 tak sa info hlasku pokusi zobrazit neskor
                    // Retazenie callbackov: ulozi stary callback a vytvori novy, ktory zavola stary + info hlasku
                    var oldClosed = dialog.getById("errorDialog")._dialogOptions.closed;
                    dialog.getById("errorDialog")._dialogOptions.closed = function() {
                        if (oldClosed) oldClosed();
                        modal.showInfoModal(sev, duration, userCanHide, infoHeader, infoText, infoText2, infoAdditional, buttons);
                    };
                }
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na schovanie infoModal hlasky pri preruseni snimania kamerou uzivatelom (Pre zobrazenie cisla karty a pinu)
    hideInfoModalPrivateAccess: function(user) {
        // Opatovne povoli tlacitko pre overovanie playerID pomocou biometrie pre zobrazenie cisla karty a pinu
        $(".user-data-pin__button").removeClass("ui-disabled");
        modal.hideInfoModal(user);
        communication.topScreen("biometryAutentification", { state: "failed", credentials: "privateAccess" });
    },

    // Funkcia na schovanie infoModal hlasky
    hideInfoModal: function(user) {
        try {
            if (user) {
                main.userAction();
                // pre schovanie aoutologoff modal aj pri kliknuti na #infoModalOverlay
                modal.toggleAutoLogOffPlayerModal(false);
            }
            dialog.isOpen("infoModalDialog") && dialog.close("infoModalDialog");
            clearTimeout(ct.errTime);
            ct.errTime = ct.errSev = null;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        }
    },

    // Funkcia vycisti rfs pre modalne okna
    clearBonusModal: function() {
        try {
            if (rfsJackpots = Object.keys(rfs.jackpotModal)) {
                rfsJackpots.forEach(function(rfsJackpot) {
                    clearInterval(rfs.jackpotModal[rfsJackpot]);
                    delete rfs.jackpotModal[rfsJackpot];
                });
            }
            main.unlockSbmButtons();
        } catch (e) {
            main.unlockSbmButtons();
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Zobrazit loading
    showLoading: function(count, notShowAsideLoader) {
        try {
            if (!$("body").hasClass("sync-lock") && !ct.countDown) $.mobile.showPageLoadingMsg();
            if (count) main.countdown(count);
            // Zobrazim loader v aside, napr. live tikety aby nebolo zablokovane UI ale iba pridavanie oddov a niektore ine funkcionality
            if (count && ticket.state.getState().liveBetDelayMs && !notShowAsideLoader) {
                more.asideLoading.toggle({show: true, timeInSec: count});
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Skryt loading
    hideLoading: function() {
        try {
            // Ak je schvalovanie tiketu v priebehu, tak neskryvame loading s odpoctom
            // - vola sa aj pri obnoveni kurzov na plachte cez main.buildPage()
            if (stored.ticketApprovalInProgress) return false;            
            if (!stored.lockedApp) $.mobile.hidePageLoadingMsg();
            main.countdown();
            // force skryjem loader v aside ak uz nebezi schvalovanie ticketu
            if (!more.asideLoading.inProgress) {
                more.asideLoading.toggle({show: false});
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na vyskladanie html pre freebet modalne okno vo vnutri univerzalneho okna
    universalModalInnerFB: function() {
        try {
            return "<div id='"
            + this.modalFor + "Content'><div id='"
            + this.modalFor + "Container'><div id='fbPlayerName'>"
            + this.fbPlayerName + ",</div><div id='fbHeader'>"
            + this.fbHeader + "</div><div id='fbInfoText'>"
            + this.fbInfoText + "</div><div id='fbAmount'>"
            + this.fbAmount + "</div><div id='fbAdditionInfo'><span id='fbAdditionInfo1'>"
            + this.fbAdditionInfo1 + " </span><span id='fbAdditionInfo2'>"
            + this.fbAdditionInfo2 + "</span></div><div id='checkboxWrapper' onmousedown='"
            + this.fbNoMoreFbModalLink + "'><input type='checkbox' id='noMoreFbModal'><label id='noMoreFbModalLabel'>"
            + this.fbNoMoreModalLabel + "</label></div><a id='fbModalButton' data-role='button' data-theme='a' onmousedown='"
            + this.fbButtonCall + "'>"
            + this.fbButton + "</a></div></div>";
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia pre vyfiltrovanie a zobrazenie freebetu do informativneho modalneho okna pri prihlaseni
    openFreebetModal: function() {
        try {
            setTimeout(function() {
                if (profile.FlatCSS && profile.Freebet && stored.Freebets && stored.Freebets.length && !dialog.isOpen("universalModalDialog")) {
                    stored.FreebetModalActive = false;
                    // Vyfiltruje nepouzite freebety a zoradi ich podla datumu
                    var orderedFreebets = stored.Freebets.map(function(fb) {
                        var fbValidDate = fb.ValidTo.replace(/\./g,'-');
                        fb.fbValidDate = new Date(fbValidDate.substr(3, 2) + "-" + fbValidDate.substr(0, 2) + "-" + fbValidDate.substr(6, 4) + " " + fbValidDate.substr(11));
                        return fb;
                    }).sort(function(a, b) {
                        // Zoradi freebety podla datumu pouzitelnosti
                        if (a.fbValidDate > b.fbValidDate) {
                            return 1;
                        } else if (a.fbValidDate < b.fbValidDate) {
                            return -1;
                        } else {
                            return 0;
                        }
                    });
                    if (stored.PlayerName && orderedFreebets && orderedFreebets[0] && orderedFreebets[0].fbValidDate) {
                        // Vypocita kolko dni ma freebet platnost
                        var dayDurationMs = 24 * 60 * 60 * 1000;
                        // Zatvori pripadne otvorene okno
                        main.closeDialog();
                        setTimeout(function() {
                            // Nastavenie popiskov, otvorenie fb okna
                            var fbModal = {
                                "modalFor": "fb",
                                "fbPlayerName": stored.PlayerName,
                                "fbHeader": texts.FbModalCongrats,
                                "fbInfoText": texts.FbModalText1,
                                "fbAmount": orderedFreebets[0].Amount + profile.Currency,
                                "fbAdditionInfo1": texts.FbModalText2 + ": " + Math.floor((orderedFreebets[0].fbValidDate - new Date(today) + dayDurationMs) / dayDurationMs) + ".",
                                "fbAdditionInfo2": texts.FbModalText4,
                                "fbNoMoreFbModalLink": "modal.noMoreFBModal();",
                                "fbNoMoreModalLabel": texts.FbModalNoMoreShow,
                                "fbButton": texts.FbModalButton,
                                "fbButtonCall": "modal.noMoreFBModal(true);"
                            }
                            dialog.open({
                                id: "universalModalDialog",
                                onOpen: function() { $("#universalModal .ui-content").empty().append(modal.universalModalInnerFB.call(fbModal)); },
                                backdropDismiss: false,
                                persistent: true,
                                parseJQM: true
                            });
                            stored.FreebetModalActive = true;
                            return true;
                        }, 50);
                    }
                    return false;
                }
            }, 1000);
            return true;
        } catch (e) {
            main.closeDialog();
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia otvara Jackpot okno
    openBonusModal: function(balance, jackpotCode) {
        try {
            console.log('balance: ' + balance + ' jackpotCode: ' + jackpotCode);
            if (stored.FreebetModalActive || stored.JackpotModalActive) {
                // Najskor sa z nativeApp posiela funkcia na otvorenie freebet modalneho okna
                if (!rfs.jackpotModal) {
                    rfs.jackpotModal = new Object();
                }
                if (!rfs.jackpotModal[jackpotCode + balance]) {
                    rfs.jackpotModal[jackpotCode + balance] = setInterval(function() {
                        modal.openBonusModal(balance, jackpotCode);
                    }, 2500);
                }
            } else if (jackpotCode && balance && !stored.JackpotModalActive) {
                if (rfs.jackpotModal && rfs.jackpotModal[jackpotCode + balance]) {
                    clearInterval(rfs.jackpotModal[jackpotCode + balance]);
                    delete rfs.jackpotModal[jackpotCode + balance];
                }
                if (stored.PlayerID) {
                    balance = shared.floor2(balance / 100, 1);
                    var jackpotModal = {
                        modalFor: 'jackpot',
                        mState: jackpotCode + " " + offer.country,
                        mHeader: texts.JackpotCongrats,
                        mInfo: texts.JackpotSublabel,
                        mBonusValue: balance + ' ' + profile.Currency,
                        mBonusClose: texts.JackpotClose
                    }
                    main.lockSbmButtons();
                    dialog.open({
                        id: "universalModalDialog",
                        onOpen: function() { $("#universalModal .ui-content").empty().append(modal.universalModalInnerJackpot.call(jackpotModal)); },
                        backdropDismiss: false,
                        persistent: true,
                        parseJQM: true
                    });
                    stored.JackpotModalActive = true;
                    return true;
                }
                return false;
            }
            return false;
        } catch (e) {
            main.createLog(2, "openBonusModal", "balance: " + balance + " type: " + type + " playerID: " + stored.PlayerID);
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        }
    },

    // Zobrazenie alebo schovanie info o konci otvaracich hodin
    toggleClosingTimeModal: function(show, remainingTime = 0) {
        try {

            // ak dostanem remaining time z volania ulozim pre pouzitie
            if (remainingTime > 0) {
                sets.ClosingTimeTimeout = remainingTime;
            }
            // show=false je zavolane iba ked dobehne timer alebo bola zavolana funkcia s hodnotou parametra == 0: modal.closingTime(0)
            if (show == true) {
                // pocitadlo a povodna hodnota pre timeout notifikacie a modal
                var countdown = sets.ClosingTimeTimeout / 1000;

                // osetrenie sekund [0|1|2-4|5]
                var secondsText = function (sec) {
                    sec = sec % 60; // len sekundy z casu v sekundach aj vacsieho ako minuta
                    switch (sec) {
                        case 0:
                            return texts.ModalClosingTime_seconds[0];
                        case 1:
                            return texts.ModalClosingTime_seconds[1];
                        case 2:
                        case 3:
                        case 4:
                            return texts.ModalClosingTime_seconds[2];
                        default:
                            return texts.ModalClosingTime_seconds[3];
                    }
                };
                // osetrenie minut [0|1|2-4|5]
                var minutesText = function (sec) {
                    var min = Math.floor(sec / 60); // len minuty z casu v sekundach
                    switch (min) {
                        case 0:
                            return texts.ModalClosingTime_minutes[0];
                        case 1:
                            return texts.ModalClosingTime_minutes[1];
                        case 2:
                        case 3:
                        case 4:
                            return texts.ModalClosingTime_minutes[2];
                        default:
                            return texts.ModalClosingTime_minutes[3];
                    }
                };
                // priprava textu pre odpocitavanie
                var countdownText = function (sec) {
                    var minText = Math.floor(sec / 60) + ' ' + minutesText(sec);
                    var secText = (sec % 60) + ' ' + secondsText(sec);
                    var translation = texts.ModalClosingTime_countdown;
        
                    // upraveny preklad aj so spojkou, preklad v tvare "{m} a {s}"
                    return translation.replace('{m}', minText).replace('{s}', secText);
                };
                // uprava modal textu o zalomenie riadka
                var modalInfoText = function () {
                    var translation = texts.ModalClosingTime;
                    if (translation.includes("{}")) {
                        translation = translation.replace('{}','<br>');
                    }
                    return translation;
                };
                // zavolanie na zobrazenie toast notifikacie o odhlaseni na hornej obrazovke
                communication.topScreen('toastNotification', {id: 'ClosingTime', timeout: (sets.ClosingTimeTimeout / 1000), show: true, text: texts.ModalClosingTime_notification + ' ' + countdownText(countdown), icon: "arrow-to-bottom-screen-stroke"});
                // odpocitavanie a aktualizacia  pre texty modal a toast
                // odpocitavanie musi bezat od momentu kedy zacalo, neresetujem ho pokial nedobehlo alebo nebolo volanie modal.closingTime(0)
                if (rfs.ClosingTimeTimer == false) {
                    rfs.ClosingTimeTimer = setInterval(function () {
                        if (countdown <= 0) {
                            modal.toggleClosingTimeModal(false, -1);
                        }
                        countdown--;
                        sets.ClosingTimeTimeout = countdown * 1000;
                        // aktualizacia času v infomodal
                        $('#closingTimeModal.err-sevClosingHours .infoHeader').html(countdownText(countdown));
                        // opakovane zavolanie na zobrazenie toast notifikacie o odhlaseni na hornej obrazovke - aktualizuje čas
                        communication.topScreen('toastNotification', {id: 'ClosingTime', timeout: (sets.ClosingTimeTimeout / 1000), show: true, text: texts.ModalClosingTime_notification + ' ' + countdownText(countdown), icon: "arrow-to-bottom-screen-stroke"});
                    }, 1000);
                }

                dialog.open({
                    id: "closingTimeModalDialog",
                    backdropDismiss: true,
                    persistent: false,
                    autoClose: sets.ClosingTimeTimeout,
                    // zavretie modal a schovanie toast notifikacie na hornej obrazovke - aj ked kliknem na backdrop, lebo inak by sa iba zavrel modal
                    closed: function() { modal.toggleClosingTimeModal(false); },
                    //fullScreen: false,
                    parseJQM: false,
                    content: `
                        <div id="closingTimeModal" class="err-sevClosingHours">
                            <span class="closeInfo">
                                <div class="ui-icon ui-icon-info"></div>
                            </span>
                            <div class="ui-bar-e">
                                <h3 class="infoHeader info-modal-text" style="">${countdownText(countdown)}</h3>
                                <div class="infoText info-modal-text" style="">${modalInfoText()}</div>
                                <button class="hideInfoButton ui-btn" data-theme="a" onmousedown="modal.toggleClosingTimeModal(false);">${texts.ModalClosingTime_button}</button>
                            </div>
                        </div>
                    `
                });
            } else {
                dialog.isOpen("closingTimeModalDialog") && dialog.close("closingTimeModalDialog");
                // vetvu volam aj ked manualne zatvaram tento modal ale vtedy nechcem resetovat timer a vypnut notifikaciu na hornej obrtazovke
                // ak ano tak poslem volanie s parametrom -1, ktory je signalom pre reset timeru a vypnutie notifikacie
                if (remainingTime == -1) {
                    communication.topScreen('toastNotification', {id: 'ClosingTime', show: false });
                    rfs.ClosingTimeTimer && clearInterval(rfs.ClosingTimeTimer);
                    rfs.ClosingTimeTimer = false;
                }
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "ClosingTimeModalError", "# ERROR: " + e);
            return false;
        }
    },

    // Funkcia volana z nativky pred koncom ortvaracich hodin
    closingTime: function(timeInSec) {
        if (timeInSec > -1) {
            modal.toggleClosingTimeModal(true, timeInSec * 1000);
        } else {
            modal.toggleClosingTimeModal(false, -1);
        }
    },

    // Funkcia volana z nativeApp sluzi na zobrazenie modalneho okna s informaciou o neaktivnej karte
    showDialogActivateCard: function(playerID, nameAndSurname, identificationNumber) {
        try {
            if (profile.IsRvoManualUnblockingAllowed && (!playerID || !nameAndSurname || !identificationNumber)) {
                throw "ShowDialogActivateCard() #playerID: " + playerID + " #nameAndSurname: " + nameAndSurname + " #identificationNumber: " + identificationNumber;
            }
            if (profile.IsRvoManualUnblockingAllowed) {
                modal.openVLCModal("OPTIONS-3", {
                    playerID: playerID,
                    nameAndSurname: nameAndSurname,
                    identificationNumber: identificationNumber
                });
            } else {
                modal.openVLCModal("OPTIONS-2");
            }
        } catch (e) {
            main.closeDialog();
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments) + " " + e);
            main.createLog(2, "ShowDialogActivateCard", e);
            return false;
        }
    },

    // Funkcia zobrazuje okno informujuce o stave obmedzeni
    openVLCModal: function(vlcModalFor, playerData, manualUnblockingDisallowed) {
        try {
            if (!vlcModalFor) vlcModalFor = ticket.playerNotAllowedForBetting();
            main.closeDialog();
            clearTimeout(rfs.vlcContentTimeout);
            delete rfs.vlcContentTimeout;

            rfs.vlcContentTimeout = setTimeout(function () {
                // Nastavenie popiskov, otvorenie vlc okna
                var vlcModal;
                switch (vlcModalFor) {
                    case "PLAYER_NOT_VERIFIED":
                        // Neverifikovany player
                        vlcModal = {
                            "modalFor": "vlc",
                            "mState": "unverified",
                            "isCustomQR": true,
                            "mHeader": texts.ModalVlcUnverifiedHeader,
                            "mInfo": texts.ModalVlcBlockedInfo,
                            "qrInfoText": texts.ModalVlcUnverifiedQrInfo[0] + " <u>" + profile.ClubVLCURL.replace(/^https:\/\/(?!www\.)/, "www.") + "</u> " + texts.ModalVlcUnverifiedQrInfo[1],
                            "mFooter": texts.ModalVlcFooter,
                            "mButtonText": texts.ModalVlcClose,
                            "mButtonCall": "main.closeDialog();"
                        }
                        break;
                    case "NO_PLAYER":
                        // Neprihlaseny player
                        vlcModal = {
                            "modalFor": "vlc",
                            "mState": "unlocking " + offer.country.toLowerCase(),
                            "isCustomQR": true,
                            "mHeader": texts.ModalVlcUnlockingHeader,
                            "mInfo": ((profile.IsRvoManualUnblockingAllowed && !manualUnblockingDisallowed)? texts.ModalVlcUnlockingInfo[0] + "<span class='text-link' onmousedown='main.manualUnblockByRVO();'>" + texts.ModalVlcUnlockingInfo[1] + "</span>": ""),
                            "mInfoCall": "main.manualUnblockByRVO();",
                            "qrInfoText": texts.ModalVlcUnlockingQrInfo,
                            "mFooter": texts.ModalVlcUnlockingFooter,
                            "mButtonText": texts.ModalVlcClose,
                            "mButtonCall": "main.closeDialog();"
                        }
                        break;
                    case "NO_PLAYER_WINCURRENCY":
                        // Player nieje prihlaseny, snazi sa podat tiket za winy
                        modal.showInfoModal("NO_PLAYER_WINCURRENCY", sets.watcherTime, false, texts.TicketWinCurrencyModalHeader, texts.TicketWinCurrencyModalLoginInfo, false, false, 
                                {
                                buttonCloseText: texts.TicketWinCurrencyModalClose,
                                buttonCloseAction: "modal.hideInfoModal();",
                                button2Text: texts.TicketWinCurrencyModalLogin,
                                button2Action: "ticket.ticketWinCurrencyModule.noPlayerWinCurrencyLoginOptions();"
                            });
                        break;
                    case "OPTIONS-3":
                        var manualUnlockContent;
                        // Novy sposob prihlasovania - Neprihlaseny player - Tuknutie na tlacidlo ODOMKNUT SPORTBOX, popripade snaha podat tiket
                        if (playerData) {
                            manualUnlockContent = "<div class='cell-text'><div>"
                                + playerData.nameAndSurname + "</div><div>"
                                + playerData.identificationNumber + "</div><a class='red-button' data-role='button' onmousedown='main.manualUnblockByPlayer("
                                + playerData.playerID + ", true);'><div class='button-label'>"
                                + texts.ModalVlcUnblockByPlayerContinue + "</div></a><a class='transparent-button' data-role='button' onmousedown='main.manualUnblockByPlayer("
                                + playerData.playerID + ", false);'><div class='button-label'>"
                                + texts.ModalVlcUnblockByPlayerEditPlayerData + "</div></a></div>";
                        } else {
                            manualUnlockContent = "<div class='cell-text'>"
                                + texts.ModalVlcOptions3Text[0] + "<a class='red-button' data-role='button' onmousedown='main.manualUnblockByRVO();'><div class='button-label'>"
                                + texts.ModalVlcUnblockByRVO + "</div></a></div>";
                        }
                        vlcModal = {
                            "modalFor": "vlc",
                            "mState": "options options-3 " + offer.country.toLowerCase(),
                            "isCustomQR": false,
                            "mHeader": texts.ModalVlcOptionsHeader,
                            "mInfo": "",
                            "qrInfoText": "<div class='cell'><h2>"
                                + texts.ModalVlcOptions1Header + "</h2><div class='cell-text'>"
                                + texts.ModalVlcOptions1Text + "</div></div><div class='cell recomended'><h3>"
                                + texts.ModalVlcOptionsRecommend + "</h3><h2>"
                                + texts.ModalVlcOptions2Header + "</h2><div class='cell-text'>"
                                + texts.ModalVlcOptions2Text + "</div></div><div class='cell'><h2>"
                                + texts.ModalVlcOptions3Header + "</h2>"
                                + manualUnlockContent + "</div>",
                            "mFooter": "",
                            "mButtonText": texts.ModalVlcClose,
                            "mButtonCall": "main.closeDialog();"
                        }
                        break;
                    case "OPTIONS-2":
                        vlcModal = {
                            "modalFor": "vlc",
                            "mState": "options options-2 " + offer.country.toLowerCase(),
                            "isCustomQR": false,
                            "mHeader": texts.ModalVlcOptionsHeader2,
                            "mInfo": "",
                            "qrInfoText": "<div class='cell'><h2>"
                                + texts.ModalVlcOptions1Header + "</h2><div class='cell-text'>"
                                + texts.ModalVlcOptions1Text + "</div></div><div class='cell recomended'><h3>"
                                + texts.ModalVlcOptionsRecommend + "</h3><h2>"
                                + texts.ModalVlcOptions2Header + "</h2><div class='cell-text'>"
                                + texts.ModalVlcOptions2Text + "</div></div>",
                            "mFooter": "",
                            "mButtonText": texts.ModalVlcClose,
                            "mButtonCall": "main.closeDialog();"
                        }
                        break;
                    case "PLAYER_UNREGISTERED":
                        vlcModal = {
                            "modalFor": "vlc",
                            "mState": "options player-unregistered " + offer.country.toLowerCase(),
                            "isCustomQR": false,
                            "mHeader": "",
                            "mInfo": "",
                            "qrInfoText": "<div class='cell'><h2>"
                                + texts.ModalVlcUnregistered1Header + "</h2><div class='cell-text'><div>"
                                + texts.ModalVlcUnregistered1Text + "</div></div><div class='step1'>"
                                + texts.ModalVlcUnregistered2Header + " " + String(playerData).toUpperCase() + "</div><div class='step2'>"
                                + texts.ModalVlcUnregistered2Text + "</div><div class='step3'>"
                                + texts.ModalVlcUnregistered3Text + "</div></div>",
                            "mFooter": "",
                            "mButtonText": texts.ModalVlcClose,
                            "mButtonCall": "main.closeDialog();"
                        }
                        break;
                    case "PLAYER_UNREGISTERED_BIOMETRY":
                        vlcModal = {
                            "modalFor": "vlc",
                            "mState": "options player-unregistered-biometry " + offer.country.toLowerCase(),
                            "isCustomQR": false,
                            "mHeader": "",
                            "mInfo": "",
                            "qrInfoText": "<div class='cell'><h2>"
                                + texts.ModalVlcUnregisteredBio1Header + "</h2><div class='cell-text'><div>"
                                + texts.ModalVlcUnregisteredBio1Text + "</div></div></div><div class='cell cell-second'><h2>"
                                + texts.ModalVlcUnregisteredBio2Header + "</h2><div class='cell-text'>"
                                + texts.ModalVlcUnregisteredBio2Text + "</div></div>",
                            "mFooter": "<div class='hightlight-text'>"
                            + texts.ModalVlcUnregisteredBio3Header + "</div><div class='basic-text'>"
                            + texts.ModalVlcUnregisteredBio3Text + "</div>",
                            "mButtonText": texts.ModalVlcClose,
                            "mButtonCall": "main.closeDialog();"
                        }
                        break;
                    case "PLAYER_UNREGISTERED_BIOMETRY_NEW_PLAYER":
                        vlcModal = {
                            "modalFor": "vlc",
                            "mState": "options player-unregistered-biometry-new-player " + offer.country.toLowerCase(),
                            "noQR": true,
                            "isCustomQR": false,
                            "mHeader": "",
                            "mInfo": "",
                            "qrInfoText": `<div class='cell' onmousedown='player.onboarding.show(false);'>
                                                <h2>${texts.ModalVlcUnregisteredBioNewPlayer1Header}</h2>
                                                <div class='cell-text'>
                                                    <div>${texts.ModalVlcUnregisteredBioNewPlayer1Text}</div>
                                                </div>
                                                <a class='red-button' data-role='button'>
                                                    <div class='button-label'>${texts.ModalVlcUnregisteredBioNewPlayerRegister}</div>
                                                </a>
                                            </div>
                                            <div class='cell cell-second' onmousedown='player.onboarding.show(true);'>
                                                <h2>${texts.ModalVlcUnregisteredBioNewPlayer2Header}</h2>
                                                <div class='cell-text'>${texts.ModalVlcUnregisteredBioNewPlayer2Text}</div>
                                                <a class='red-button' data-role='button'>
                                                    <div class='button-label'>${texts.ModalVlcUnregisteredBioNewPlayerLogin}</div>
                                                </a>
                                            </div>`,
                            "mFooter": "",
                            "mButtonText": texts.ModalVlcClose,
                            "mButtonCall": "main.closeDialog(); player.onboarding.stop();"
                        }
                        break;
                    case "PLAYER_GAMBLING_PROHIBITED":
                    case "PLAYER_GAMBLING_PROHIBITED_IN_GAMING_CLUB":
                        // Player sa nachadza v RVO
                        modal.showErrObj(1, 5, {err1: texts.NoEventsHeader, err2: texts.Tc_ERR_PLAYER_GAMBLING_PROHIBITED, errType: "NoEventsHeader"});
                        break;
                    case "PLAYER_BET_REQUIRES_BIOMETRIC_LOGIN":
                        // Player nieje prihlaseny, snazi sa podat tiket ale ma povolene len prihlasovanie pomocou biometrie IsBiometricLoginOnly = true
                        modal.showInfoModal("PLAYER_BET_REQUIRES_BIOMETRIC_LOGIN", sets.watcherTime, false, texts.ModalVlcBiometricLoginOnlyLabel, texts.ModalVlcBiometricLoginOnlyText, false, false,
                        {
                            buttonCloseText: texts.ModalVlcBiometricLoginOnlyCancel,
                            buttonCloseAction: "modal.hideInfoModal();",
                            button2Text: texts.BiometryLoginLabel,
                            button2Action: "player.biometryLogin('biometryLogin');"
                        });
                        break;
                    case "PLAYER_UNREGISTERED_BIOMETRIC_LOGIN_ONLY":
                        // Player ma registrovanu karticku ktoru prilozil k citacke ciarovych kodov, ale na SB je povolene len prihlasovanie pomocou biometrie IsBiometricLoginOnly = true
                        modal.showInfoModal("PLAYER_UNREGISTERED_BIOMETRIC_LOGIN_ONLY", sets.watcherTime, false, texts.BiometryLoginModalFailed, texts.ModalVlcPlayerRegisteredBiometricLoginOnlyLabel, false,
                        `<div class="only-biometric">
                            <div class="only-biometric__qr">
                                <img src="/stylesheets/images/vlc-qr-code-${offer.country}.png"/>
                            </div>
                            <div class="only-biometric__text only-biometric__text--multi">
                                <div class="only-biometric__text-cell only-biometric__text-cell--caption">${texts.ModalVlcPlayerRegisteredBiometricLoginOnlyQRHeader}</div>
                                <div class="only-biometric__text-cell">${texts.ModalVlcPlayerRegisteredBiometricLoginOnlyQRText.split('{0}')[0]} ${profile.ClubVLCURL.replace(/^https:\/\/(?!www\.)/, "www.")} ${texts.ModalVlcPlayerRegisteredBiometricLoginOnlyQRText.split('{0}')[1]}</div>
                            </div>
                        </div>`,
                        {
                            buttonCloseText: texts.ModalVlcPlayerRegisteredBiometricLoginOnlyCancel,
                            buttonCloseAction: "modal.hideInfoModal();",
                            button2Text: texts.BiometryLoginFailedRepeatButton,
                            button2Action: "player.biometryAgain(true);"
                        });
                        break;
                    case "PLAYER_REGISTERED_BIOMETRIC_LOGIN_ONLY":
                        // Player nema registrovanu karticku ktoru prilozil k citacke ciarovych kodov, ale na SB je povolene len prihlasovanie pomocou biometrie IsBiometricLoginOnly = true
                        modal.showInfoModal("PLAYER_REGISTERED_BIOMETRIC_LOGIN_ONLY", sets.watcherTime, false, texts.ModalVlcPlayerUnregisteredBiometricLoginOnlyHeader, texts.ModalVlcPlayerUnregisteredBiometricLoginOnlyLabel, false,
                         `<div class="only-biometric">
                             <div class="only-biometric__qr">
                                 <img src="/stylesheets/images/vlc-qr-code-${offer.country}.png"/>
                             </div>
                             <div class="only-biometric__text">
                                ${texts.ModalVlcPlayerUnregisteredBiometricLoginOnlyQRText.split('{0}')[0]} ${profile.ClubVLCURL.replace(/^https:\/\/(?!www\.)/, "www.")} ${texts.ModalVlcPlayerUnregisteredBiometricLoginOnlyQRText.split('{0}')[1]}
                             </div>
                         </div>`,
                         {
                            button2CloseText: texts.ModalVlcPlayerUnregisteredBiometricLoginOnlyCancel,
                            button2CloseAction: "modal.hideInfoModal();"
                         });
                        break;
                    default:
                        // Bez default
                        break;
                }
                if (vlcModal && !(dialog.isOpen("universalModalDialog") || dialog.isOpen("infoModalDialog"))) {
                    dialog.open({
                        id: "universalModalDialog",
                        onOpen: function() { $("#universalModal .ui-content").empty().append(modal.universalModalInnerVLC.call(vlcModal)); },
                        backdropDismiss: false,
                        persistent: true,
                        parseJQM: true
                    });
                    if (vlcModal.isCustomQR) {
                        main.generateUnlockingQRcode();
                    }
                }
            }, 50);
            return true;
        } catch (e) {
            clearTimeout(rfs.vlcContentTimeout);
            delete rfs.vlcContentTimeout;
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia vyhodnocuje zobrazovanie potvrdzovacej error hlasky, pouziva sa pri moznej zmene exspiracii oddu a zmeny kurzu
    errorResolver: function() {
        try {
        //
        var hideAll = false;
        // Aktualizuje zoznam expirovanych oddov ktore boli skryte
        list.OddsExpiredHidden = list.OddsExpired.interSection(list.OddsExpiredHidden);
        // Odobratie ecspirovanych oddov z listu oddov ktorym sa zmenil kurz
        list.OddsRateChanged = list.OddsRateChanged.diff(list.OddsExpired);

        if (list.OddsExpired.length || list.OddsRateChanged.length) {
            // Existuju expirovane oddy
            if (list.OddsExpired.diff(list.OddsExpiredHidden).length) {
                // Ak su nejake oddy exspirovane a sucasne je medzi skrytimy a zobrazenymi rozdiel, vytvori error hlasku o exspiracii odov
                var errC = modal.parseErrors(["ERR_ODDEXP:" + list.OddsExpired.join(";ERR_ODDEXP:")]);
                if (stored.ActualError && stored.ActualError.errorTypes && stored.ActualError.errorTypes.interSection(offer.parallelErrTypes).length) {
                    modal.showErrObj(1, sets.btnErrorsTime, {errObj: errC, force: false});
                } else {
                    modal.showErrObj(1, sets.btnErrorsTime, {errObj: errC, force: true});
                }
            }
            if (list.OddsRateChanged.length) {
                var errC = modal.parseErrors(["ERR_RATEX:" + list.OddsRateChanged.join(";ERR_RATEX:")]);
                modal.showErrObj(1, sets.btnErrorsTime, {errObj: errC});
            }
        } else {
            // Niesu exspirovane oddy
            if (stored.ActualError && stored.ActualError.errorTypes) {
                // Je zobrazena hlaska
                if ((actualBtn = stored.ActualError.errorTypes.interSection(offer.btnErrors)) && actualBtn.length) {
                    // Je zobrazeny button error
                    if (stored.ActualError.errorTypes.length > 1) {
                        // Je zobrazenych viac ako jedna hlaska
                        hideAll = modal.clearErrorType(offer.btnErrors[0]);
                    } else {
                        // Je zobrazeny jediny button error
                        hideAll = modal.clearErrorType(actualBtn[0]);
                    }
                }
                if (hideAll) modal.hideErr();
            }
        }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na spracovanie ERROR hlasok do ul-li zoznamov
    parseErrors: function(errors, maxBetReason, amount) {
        try {
            if (errors === Object(errors) && errors.length) {
                var errC = {};
                // Prechadza jednotlive chyby (pole)
                $.each(errors, function (i, error) {
                    if (error) {
                        if ((/MASTERDOWN/).test(error)) {
                            errC[0] = texts.Tc_INSUFICIENT_FOUNDS;
                            main.createLog(2, "CentralTicketError", "ERROR: " + error);
                        } else if ((/Object reference not set/).test(error)) {
                            errC[0] = texts.OddErr;
                            errC[1] = texts.Tc_INSUFICIENT_FOUNDS;
                            main.createLog(2, "CentralTicketError", "ERROR: " + error);

                        } else {
                            error = error.split(";")
                            if (error.includes("")) {
                                error.pop();
                            }
                            errC = modal.makeErrorStructure(error, maxBetReason, amount);
                            if (errC["ERR_RATEX"]) {
                                list.OddsRateChanged = errC["ERR_RATEX"].map(function(ratexErr){ return Number(ratexErr.errorSpec) });
                            }
                        }
                    }
                });
                return errC;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    parseErrorsStrings: function(label, maxBetReason, amount) {
        if (label) {
            var errContainer = [];

            // Ak nenajde preklad danej chyby tak vypise "Systemova chyba"
            if (!(errContainer[0] = texts["Tc_" + label[0]])) {
                errContainer[0] = texts.Tc_INSUFICIENT_FOUNDS;
                main.createLog(3, "CentralTicketError", "ERROR LABEL: " + label[0]);
            }

            // Ine hlasky ako ERR_PLACING_BET, DBPLACEBET_FAILED maju aj rozsirenu info
            if (label[1]) {
                // Rozsirena info
                switch (label[0]) {
                    case "ERR_RATEX":           // OddList
                        switch (stored.AllowedRateChange) {
                            case "Up":
                                errContainer[0] = texts.Tc_ERR_RATEX_DOWN;
                                break;
                            case "None":
                                errContainer[0] = texts.Tc_ERR_RATEX_NONE;
                                break;
                            case "All":
                            default:
                                // Rozladenie ulozenej stored.AllowedRateChange s ticket sluzbou
                                // Nastavi preklad erroru a chybu zaloguje
                                errContainer[0] = texts.Tc_ERR_RATEX_NONE;
                                main.createLog(2, "AllowedRateChange_Desynchronized", "stored.AllowedRateChange: " + stored.AllowedRateChange);
                                // Ak existuje nastavi poslednu znamu hodnotu zo stored.AllowedRateChange inak nastavi default hodnotu
                                ticket.allowedRateChange(stored.AllowedRateChange || profile.AllowedRateChangeDefault);
                                break;
                        }
                        break;
                    case "ODDnotonticket":      // OddList
                    case "ERR_ODDEXP":          // OddList
                    case "ERR_LIVEBAD":         // OddList
                        errContainer[0] = texts.Tc_ERR_ODDSUS;
                        errContainer[1] = modal.parseErrorsEvent(label[1]);
                        break;
                    case "ERR_EDIT_ODDEXP":     // OddList && edit
                    case "ERR_EDIT_REM_ODDEXP":
                        errContainer[1] = modal.parseErrorsEvent(label[1]);
                        break;
                    case "ERR_MINCB":           // Value & Odd
                        if (label[2]) errContainer[0] += " " + label[2];
                        errContainer[1] = modal.parseErrorsEvent(label[1]);
                        break;
                    case "ERR_EVT":             // OddList
                    case "ERR_EVT_VIC":         // OddList
                    case "ERR_EVT_DATE":        // OddList
                    case "ERR_EVTRST":          // OddList
                    case "ERR_ELCRST":          // OddList
                    case "ERR_CR_LCUP":         // OddList
                    case "ERR_CR_LCUPCOMP":     // OddList
                    case "ERR_CR_LCUPOVER":     // OddList
                    case "ERR_CR_REG":          // OddList
                    case "ERR_CR_REGCOMP":      // OddList
                    case "INACTIVE":            // OddList
                    case "RATE_DIFF":           // OddList
                    case "RATE_LEQ1":           // OddList
                        errContainer[1] = modal.parseErrorsEvent(label[1]);
                        break;
                    case "ERR_MAXODDS":
                    case "ERR_MAXCOMBI":
                        label = label[1].split("/");
                        if (label[1]) {
                            errContainer[0] += " " + label[1];
                        } else {
                            errContainer[0] += " " + label[0];
                        }
                        break;
                    case "ERR_NETBET":
                    case "ERR_NETWIN":
                    case "ERR_BETLIMIT":
                        label = label[1].split("/");
                        errContainer[1] = modal.parseErrorsEvent(label[0].split("-")[0]) + " (" + label[0].split("-")[1] + ") ";
                        label = shared.floor2(label[1].split("[")[0].replace(",", "."));
                        if (amount) label -= amount;
                        if (label > 0) {
                            errContainer[1] += shared.floor2(label, 1) + " " + profile.Currency;
                        } else {
                            errContainer[1] += " - " + texts.Tc_ERR_LIMIT_REACHED;
                        }
                        break;
                    case "ERR_LIMIT":
                        errContainer[1] = ticket.parseMaxBetReason(label[1]);
                        break;
                    case "ERR_MINOVERALLBET":
                        label[1] = parseFloat(label[1].replace(",", "."));
                        errContainer[0] += " " + shared.floor2(label[1], 1) + " " + profile.Currency;
                        break;
                    case "ERR_MINBET":
                        label[1] = parseFloat(label[1].replace(",", "."));
                        if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && label[1] < stored.MinDeposit) errContainer[0] = texts.TicketErr13;
                        errContainer[0] += " " + shared.floor2(label[1], 1) + " " + profile.Currency;
                        break;
                    case "ERR_MIN_GROSSBET":
                        errContainer[0] += " " + shared.floor2((Math.ceil(parseFloat(label[1].replace(",", ".")) * 100) / 100), 1) + " " + profile.Currency;
                        break;
                    case "ERR_MAXBET":
                    case "DBMAXBET":
                        if (ticket.state.getState().isEditTicket) {
                            label[1] = parseFloat(label[1].replace(",", "."));
                            if (shared.floor2(label[1]) > 0) {
                                errContainer[0] += " " + shared.floor2((Math.ceil((label[1] * stored.FeeAmount) * 100) / 100), 1) + " " + profile.Currency;
                                errContainer[1] = texts.Tc_ERR_MAXBET_EDIT;
                            }
                            break;
                        }
                    case "DBMAXOKBET":
                        label[1] = parseFloat(label[1].replace(",", "."));
                        if (shared.floor2(label[1]) > 0) {
                            if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                                errContainer[0] += " " + shared.floor2((Math.ceil((label[1] * stored.FeeAmount) * 100) / 100), 1) + " " + profile.Currency;
                            } else {
                                errContainer[0] += " " + texts.Tc_ERR_MAXBET_AVERAGE + "<div>" + shared.floor2(label[1], 1) + " " + profile.Currency + "</div>";
                            }
                        } else {
                            errContainer[0] = texts.TicketErr11;
                        }
                        if (maxBetReason) {
                            errContainer[1] = ticket.parseMaxBetReason(maxBetReason);
                            main.createLog(3, "CentralTicketError", "MaxBetReason: " + maxBetReason + " # " + errContainer[1]);
                        }
                        break;
                    // Value: vsetky chyby bez doplnujucej info
                    case "ERR_GROSSBET":
                    case "ERR_LAST_SPELL":
                    case "ERR_RATE_MAX":
                    case "ERR_EDIT_ODDREM_RATE":
                    case "ERR_EDIT_BAD_VERSION":
                    default:
                        errContainer[0] += " " + label[1];
                        break;
                }
            }
            return errContainer;
        }
    },

    // Doplni nazvy teamov do errov hlasky tiketu
    parseErrorsEvent: function(odds, formatting) {
        try {
            if (odds) {

                odds = odds.toString().split(",");
                var event = "";
                var team1, team2;
                if (!formatting) event = "<ul style='list-style-type:disc;font-size: 20px;color: #777d83;'>";

                // Prejde event list
                $.each(odds, function (o, eventID) {
                    var eventOnTicket = null;
                    if ((eventOnTicket = $("#ticketList #" + eventID.split(' ').join(''))) && eventOnTicket.length) {
                        event += "<li>";
                        team1 = eventOnTicket.addClass("highlight").find("#titleHome").text();
                        team2 = eventOnTicket.find("#titleAway").text();
                        if (team1) event += team1;
                        if (team2) event += " vs. " + team2;
                        event += "</li>";
                    }
                });
                if (((event.length === 9) && event.match("<li></li>") || (!team1 & !team2))) {
                    return "";
                } else {
                    if (!formatting) {
                        event += "</ul>";
                    }
                    return (event);
                }

            } else {
                return "";
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return "";
        }
    },

    // Funkcia vytvara strukturu objektu pre error hlasku
    makeErrorStructure: function(errorsToParse, maxBetReason, amount) {
        try {
            var errC = {};
            var errorsArray = [];
            // Len unikatne errory
            errorsToParse = errorsToParse.filter(function(error, e, arrayE) {
                return arrayE.indexOf(error) == e;
            });
            // Vytvori pole objektov s errorType a errorSpec
            for (ep = 0; ep < errorsToParse.length; ep++) {
                var contains = false;
                var pError = errorsToParse[ep].split(":"); // Error na spracovanie
                if (stored.ActualError && stored.ActualError.errorTypes) {
                    for (et = 0; et < stored.ActualError.errorTypes.length; et++) {
                        // Prechadza errorTypes aktualne zobrazenej hlasky
                        if ((pError[0] !== "ERR_ODDEXP") && stored.ActualError[stored.ActualError.errorTypes[et]]) {
                            // Ak nova hlaska pre odd nieje o expirovanom odde
                            if (stored.ActualError[stored.ActualError.errorTypes[et]].some(function(ae) {return (Number(ae.errorSpec) === Number(pError[1]))})) {
                                // Vylucenie oddu z listu
                                contains = true;
                            }
                        }
                    };
                }
                if (!contains) {
                    errorsArray.push({
                        errorType: pError[0],
                        errorSpec: pError[1],
                        errorSpecDetail: pError[2]
                    });
                }
            }

            if (!errorsArray.length) {
                return false;
            }

            // Premapuje pole objektov do skupin podla errorType, odstrani prazdne errorType
            Object.keys(errC = errorsArray.groupBy("errorType", true)).forEach(function(errType, index, arr) {
                // Parsovanie nadpisu hlasky
                var errActual = modal.parseErrorsStrings({0: errType, 1: errC[errType][0].errorSpec, 2: errC[errType][0].errorSpecDetail}, maxBetReason, amount);
                errC[errType + "_Label"] = errActual[0];

                // Do errorTypes prida novy typ erroru pokial sa este nenachadza v poli
                if (!errC.errorTypes) errC.errorTypes = [];
                if (!errC.errorTypes.includes(errType)) {
                    errC.errorTypes.push(errType);
                }

                errC[errType].forEach(function(gea, i, a) {
                    // Parsovanie popisu pod nadpisom
                    if (errActual[1]) {
                        errC[errType][i]["errorContent"] = errActual[1];
                    } else {
                        errC[errType][i]["errorContent"] = modal.parseErrorsEvent(errC[errType][i].errorSpec, false);
                    }
                });
            });
            return errC;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        }
    },

    // Funkcia na zobrazenie hlášky automatického odhlásenia po timeout
    toggleAutoLogOffPlayerModal: function(show) {
        try {
                        
            // reset timera pri zavolani
            clearInterval(rfs.LogOffPlayerTimer);
            rfs.LogOffPlayerTimer = false;
            if (show == true) {
                // pocitadlo pre texty 
                var countdown = sets.watcherTimePlayerNotify / 1000;
                // osetrenie sekund [0|1|2-4|5]
                var secondsText = function (sec) {
                    switch (sec) {
                        case 0:
                            return texts.ModalAutoLogOffPlayer_seconds[0];
                        case 1:
                            return texts.ModalAutoLogOffPlayer_seconds[1];
                        case 2:
                        case 3:
                        case 4:
                            return texts.ModalAutoLogOffPlayer_seconds[2];
                        default:
                            return texts.ModalAutoLogOffPlayer_seconds[3];
                    }
                };
                // text pre modal
                var modalText = function(sec) {
                    var translation = texts.ModalAutoLogOffPlayer.replace('{#}', sec).replace('{s}', secondsText(sec)).split('{}');
                    return `<span class="text">${translation[0]}</span><span class="countdown">${translation[1]}</span>`;
                };
                // text pre notifikaciu
                var notificationText = function(sec) {
                    return texts.ModalAutoLogOffPlayer_notification.replace('{#}', `<span class="time">${sec}</span>`).replace('{s}', secondsText(sec));
                };
                // zobrazenie modal na spodnej obrazovke
                dialog.open({
                    id: "autoLogoffModalDialog",
                    backdropDismiss: true,
                    persistent: false,
                    autoClose: sets.watcherTimePlayerNotify,
                    // zavretie modal a schovanie toast notifikacie na hornej obrazovke - aj ked kliknem na backdrop lebo inak by sa iba zavrel modal
                    closed: function() { modal.toggleAutoLogOffPlayerModal(false); },
                    //fullScreen: false,
                    parseJQM: false,
                    content: `
                        <div id="autoLogoffModal" class="err-sevAutoLogOffPlayer">
                            <span class="closeInfo">
                                <span class="ui-icon ui-icon-info"></span>
                            </span>
                            <div class="ui-bar-e two-buttons">
                                <h3 class="infoHeader info-modal-text"></h3>
                                <div class="infoText info-modal-text">${modalText(countdown)}</div>
                                <button class="hideInfoButton ui-btn" onmousedown="LogOffPlayer();modal.toggleAutoLogOffPlayerModal(false)">
                                    ${texts.ModalAutoLogOffPlayer_button_logoff}
                                </button>
                                <button class="confirmInfoButton ui-btn" onmousedown="modal.toggleAutoLogOffPlayerModal(false)">
                                    ${texts.ModalAutoLogOffPlayer_button_stay}
                                </button>
                            </div>
                        </div>
                    `
                });

                // zavolanie na zobrazenie toast notifikacie o odhlaseni na hornej obrazovke
                communication.topScreen('toastNotification', {id: 'AutoLogOff', timeout: sets.watcherTimePlayerNotify / 1000, show: true, text: notificationText(countdown), icon: 'arrow-to-bottom-screen-stroke'});
                // odpocitavanie a aktualizacia infomodal a notifikacie
                rfs.LogOffPlayerTimer = setInterval(function () {
                    countdown--;
                    // aktualizacia času v infomodal
                    $('#autoLogoffModal .infoText').html(modalText(countdown));
                    // opakovane zavolanie na zobrazenie toast notifikacie o odhlaseni na hornej obrazovke - aktualizuje čas
                    communication.topScreen('toastNotification', {id: 'AutoLogOff', timeout: sets.watcherTimePlayerNotify / 1000, show: true, text: notificationText(countdown), icon: "arrow-to-bottom-screen-stroke"});
                    if (countdown == 0) {
                        modal.toggleAutoLogOffPlayerModal(false);
                    }
                }, 1000);
            } else {
                dialog.isOpen("autoLogoffModalDialog") && dialog.close("autoLogoffModalDialog");
                // schovanie toast notifikacie na hornej obrazovke
                communication.topScreen('toastNotification', {id: 'AutoLogOff', show:false});
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "toggleAutoLogOffPlayerModalError", "# ERROR: " + e);
            return false;
        }
    },

    // ClearErrorType
    clearErrorType: function(errorTypeToHide) {

        // Ak sa jedna o ERR_ODDEXP Error
        if (errorTypeToHide === "ERR_ODDEXP") {
            for (oe = 0; oe < list.OddsExpired.length; oe++) {
                // Prechadza kazdy aktualne zobrazeny exspirovany odd
                if (!list.OddsExpiredHidden.includes(list.OddsExpired[oe])) {
                    list.OddsExpiredHidden.push(list.OddsExpired[oe]);
                }
            }
        } else if (errorTypeToHide === "ERR_RATEX") {
            list.OddsRateChanged = [];
        }

        // Odstrani hlasku
        if (stored.ActualError && stored.ActualError.errorTypes.includes(errorTypeToHide)) {
            $('#error').find(".err2[error-type='" + errorTypeToHide + "']").remove();
            delete stored.ActualError[errorTypeToHide + "_Label"];
            $('#error').find(".err1[error-type='" + errorTypeToHide + "']").remove();
            delete stored.ActualError[errorTypeToHide];
            // Vymaze aj errorType
            stored.ActualError.errorTypes = stored.ActualError.errorTypes.filter(function(item, i) {return item !== errorTypeToHide});
            // Vymaze aj casovac
            clearTimeout(ct.errTime[errorTypeToHide]);
            delete ct.errTime[errorTypeToHide];
        }

        if (stored.ActualError && stored.ActualError.errorTypes.length) {
            return false;
        }
        // Ak sa jednalo o posledny error vrati true
        return true;
    },

    // Funkcia sluzi na zobrazenie univerzalneho modalneho okna
    htmlModal: {
        show: function (cssClass, data) {
            // get dialog element
            var modalEl = document.getElementById('html-modal');

            // pridanie custom class pre infomodal (loterie, ...)
            modalEl.classList.add(cssClass);

            // odstranienie custom class po zatvoreni modal
            modalEl.addEventListener('close', function (event) {
                event.target.classList.remove(cssClass);
                // vycistenie obsahu modalu
                modal.htmlModal.clear(modalEl)
            })
            
            // naplnenie modal
            this.fill(modalEl, data);
            
            // zobrazenie modal
            modalEl.showModal();
        },
        fill: function (modalEl, data) {
            // naplnenie modal
            modalEl.querySelector('.modal__title').innerHTML = data.header;
            modalEl.querySelector('.modal__content').innerHTML = data.content;
        },
        clear: function (modalEl) {
            // vycistenie obsahu modalu
            modalEl.querySelector('.modal__title').innerHTML = "";
            modalEl.querySelector('.modal__content').innerHTML = "";
        }
    }
};
